var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/utils/meta-theme.js
var metaThemeColorElement = document.querySelector("meta[name=theme-color]");
var MetaThemeColor = class {
  /**
   * Set modal color as the theme color.
   */
  setModalColor() {
    const themeColor = "#fff";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set modal color as the theme color.
   */
  setAnnouncementBarColor() {
    const themeColor = "#242424";
    metaThemeColorElement.setAttribute("content", themeColor);
  }
  /**
   * Set default color as the theme color.
   */
  setDefaultColor() {
    const announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
    const color = "#fff";
    if (announcementBarElement.classList.contains("js-window-scrolled")) {
      metaThemeColorElement.setAttribute("content", color);
    } else {
      this.setAnnouncementBarColor();
    }
  }
  /**
   * Set custom color as theme color.
   * 
   * @param {string} color 
   */
  setCustomColor(color) {
    metaThemeColorElement.setAttribute("content", color);
  }
};
var meta_theme_default = new MetaThemeColor();

// src/utils/announcement-bar.js
var AnnoucementBar = class {
  constructor() {
    /**
     * Hide announcement bar.
     */
    __publicField(this, "hideAnnouncementBar", () => {
      if (this.headerElement && this.announcementBarElement) {
        const countdownElement = document.querySelector(".announcement-bar__countdown");
        this.annoucementBarState = "closed";
        this.announcementBarElement.classList.add("js-window-scrolled");
        this.announcementBarElement.style.clipPath = "inset(0% 0% 100% 0%)";
        this.headerElement.classList.add("js-window-scrolled");
        this.headerElement.style.transform = "translateY(0px)";
        if (countdownElement) {
          countdownElement.style.opacity = "0";
          countdownElement.style.pointerEvents = "none";
        }
        meta_theme_default.setDefaultColor();
      }
    });
    /**
     * Show announcement bar.
     */
    __publicField(this, "showAnnouncementBar", () => {
      const announcementBarHeight = this.announcementBarElement.offsetHeight;
      const countdownElement = document.querySelector(".announcement-bar__countdown");
      const countdownHeight = countdownElement ? countdownElement.offsetHeight : 0;
      const isMobile = window.innerWidth < 1024;
      const totalHeight = isMobile ? announcementBarHeight + countdownHeight : announcementBarHeight;
      if (this.headerElement && this.announcementBarElement) {
        this.annoucementBarState = "visible";
        this.headerElement.style.transform = `translateY(${totalHeight}px)`;
        this.announcementBarElement.style.clipPath = "inset(0% 0% 0 0%)";
        this.announcementBarElement.classList.remove("js-window-scrolled");
        this.headerElement.classList.remove("js-window-scrolled");
        if (countdownElement) {
          countdownElement.style.opacity = "1";
          countdownElement.style.pointerEvents = "auto";
        }
        meta_theme_default.setAnnouncementBarColor();
      }
    });
    __publicField(this, "handleWindowScroll", () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > this.offset) {
        if (this.annoucementBarState === "visible") {
          this.hideAnnouncementBar();
        }
      } else {
        this.showAnnouncementBar();
      }
    });
    /**
     * Handle announcement bar scroll.
     * 
     * @param {string} defaultState 
     */
    __publicField(this, "handleAnnouncementBarScroll", (defaultState) => {
      if (defaultState && defaultState === "visibile") {
        this.showAnnouncementBar();
      }
      window.addEventListener("scroll", () => this.handleWindowScroll());
    });
    this.announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
    this.announcementBarHeight = this.announcementBarElement.offsetHeight;
    this.headerElement = document.querySelector(".header");
    this.countdownElement = document.querySelector(".announcement-bar__countdown");
    this.headerHeight = this.headerElement.offsetHeight;
    this.countdownHeight = this.countdownElement ? this.countdownElement.offsetHeight : 0;
    const isMobile = window.innerWidth < 1024;
    const totalAnnouncementHeight = isMobile ? this.announcementBarHeight + this.countdownHeight : this.announcementBarHeight;
    this.offset = totalAnnouncementHeight * 3;
    this.annoucementBarState = "visible";
  }
};
var { hideAnnouncementBar, showAnnouncementBar, handleAnnouncementBarScroll } = new AnnoucementBar();

// src/extenders/desktop-navigation.js
var DesktopNavigation = class extends HTMLElement {
  constructor() {
    super();
    /**
     * Close all desktop navigation items.
     */
    __publicField(this, "closeAllDesktopNavigationItems", () => {
      const allNavigationParentElements = document.querySelectorAll(".desktop-navigation .navigation-parent");
      allNavigationParentElements.forEach((navigationParentElement) => {
        const ariaLabelledBy = navigationParentElement.getAttribute("aria-labelledby");
        navigationParentElement.classList.remove("js-active");
        const allDesktopNavigationHandlerElements = document.querySelectorAll(`.js-handle-desktop-navigation[aria-controls="${ariaLabelledBy}"]`);
        allDesktopNavigationHandlerElements.forEach((desktopNavigationHandlerElement) => {
          desktopNavigationHandlerElement.ariaExpanded = "false";
        });
      });
    });
    /**
     * Detect if click is outside desktop navigation and header.
     * 
     * @param {*} event 
     */
    __publicField(this, "detectIfOutsideDesktopNavigation", (event) => {
      var _a;
      const headerInnerElement = document.querySelector(".header__inner");
      let target = event.target;
      do {
        if (((_a = target == null ? void 0 : target.classList) == null ? void 0 : _a.contains("navigation-parent")) || target == headerInnerElement) {
          return;
        }
        target = target.parentNode;
      } while (target);
      this.closeDesktopNavigation();
    });
    /**
     * Set listeners for closing desktop navigation.
     */
    __publicField(this, "setListernersForClosingDesktopNavigation", () => {
      window.addEventListener("scroll", (event) => {
        const targetElement = event.target;
        if (targetElement == null ? void 0 : targetElement.classList) {
        } else {
          this.closeDesktopNavigation();
        }
      }, true, { passive: true });
      const allNavigationParentElements = document.querySelectorAll(".navigation-parent");
      const prepareForClosingDesktopNavigation = () => {
        const closeDesktopNavigationTimeout = setTimeout(() => {
          this.closeDesktopNavigation(this.desktopNavigationElement);
        }, 100);
        allNavigationParentElements.forEach((navigationParentElement) => {
          navigationParentElement.addEventListener("mouseenter", () => clearTimeout(closeDesktopNavigationTimeout), { passive: true });
        });
        this.allDesktopNavigationHandlerElements.forEach((desktopNavigationHandlerElement) => {
          desktopNavigationHandlerElement.addEventListener("mouseenter", () => clearTimeout(closeDesktopNavigationTimeout), { passive: true });
        });
      };
      allNavigationParentElements.forEach((navigationParentElement) => {
        navigationParentElement.addEventListener("mouseleave", () => prepareForClosingDesktopNavigation(), { passive: true });
      });
      document.addEventListener("click", (event) => this.detectIfOutsideDesktopNavigation(event), true, { passive: true });
    });
    /**
     * Remove event listeners for closing desktop navigation.
     */
    __publicField(this, "removeListernersForClosingDesktopNavigation", () => {
      window.removeEventListener("scroll", (event) => {
        const targetElement = event.target;
        if (targetElement == null ? void 0 : targetElement.classList) {
        } else {
          this.closeDesktopNavigation();
        }
      }, true, { passive: true });
      const allNavigationParentElements = document.querySelectorAll(".navigation-parent");
      const prepareForClosingDesktopNavigation = () => {
        const closeDesktopNavigationTimeout = setTimeout(() => {
          this.closeDesktopNavigation(this.desktopNavigationElement);
        }, 100);
        allNavigationParentElements.forEach((navigationParentElement) => {
          navigationParentElement.removeEventListener("mouseenter", () => clearTimeout(closeDesktopNavigationTimeout), { passive: true });
        });
        this.allDesktopNavigationHandlerElements.forEach((desktopNavigationHandlerElement) => {
          desktopNavigationHandlerElement.removeEventListener("mouseenter", () => clearTimeout(closeDesktopNavigationTimeout), { passive: true });
        });
      };
      allNavigationParentElements.forEach((navigationParentElement) => {
        navigationParentElement.removeEventListener("mouseleave", () => prepareForClosingDesktopNavigation(), { passive: true });
      });
      document.removeEventListener("click", (event) => this.detectIfOutsideDesktopNavigation(event), true, { passive: true });
    });
    /**
     * Remove the listeners setting the banner image.
     */
    __publicField(this, "removeListenersForBannerImage", () => {
      const activeNavigationParentElement = document.querySelector(".navigation-parent.js-active");
      const allLinksInParentNavigationElement = activeNavigationParentElement == null ? void 0 : activeNavigationParentElement.querySelectorAll(".item__link");
      const parentElementBannerImage = activeNavigationParentElement == null ? void 0 : activeNavigationParentElement.querySelector(".navigation-parent__banner-holder");
      allLinksInParentNavigationElement == null ? void 0 : allLinksInParentNavigationElement.forEach((linkInParentNavigationElement) => {
        const hoverImageUrl = linkInParentNavigationElement.getAttribute("data-hover-image");
        if (hoverImageUrl) {
          linkInParentNavigationElement.addEventListener("mouseenter", () => {
            const bannerImageElement = parentElementBannerImage.querySelector("img");
            const newBannerImage = new Image();
            parentElementBannerImage.ariaBusy = "true";
            newBannerImage.width = 1500;
            newBannerImage.height = 1500;
            newBannerImage.alt = "Banner image";
            newBannerImage.src = hoverImageUrl;
            newBannerImage.onload = () => {
              bannerImageElement.replaceWith(newBannerImage);
              parentElementBannerImage.ariaBusy = "false";
            };
          });
        }
      });
    });
    /**
     * Set listeners for setting the banner image.
     */
    __publicField(this, "setListenersForBannerImage", () => {
      const activeNavigationParentElement = document.querySelector(".navigation-parent.js-active");
      const allLinksInParentNavigationElement = activeNavigationParentElement.querySelectorAll(".item__link");
      const parentElementBannerImage = activeNavigationParentElement.querySelector(".navigation-parent__banner-holder");
      allLinksInParentNavigationElement.forEach((linkInParentNavigationElement) => {
        const hoverImageUrl = linkInParentNavigationElement.getAttribute("data-hover-image");
        if (hoverImageUrl) {
          linkInParentNavigationElement.addEventListener("mouseenter", () => {
            const bannerImageElement = parentElementBannerImage.querySelector("img");
            const newBannerImage = new Image();
            parentElementBannerImage.ariaBusy = "true";
            newBannerImage.width = 1500;
            newBannerImage.height = 1500;
            newBannerImage.alt = "Banner image";
            newBannerImage.src = hoverImageUrl;
            newBannerImage.onload = () => {
              bannerImageElement.replaceWith(newBannerImage);
              parentElementBannerImage.ariaBusy = "false";
            };
          });
        }
      });
    });
    /**
     * Open desktop navigation.
     */
    __publicField(this, "openDesktopNavigation", (desktopNavigationHandlerElement) => {
      const openDesktopNavigationTimeout = setTimeout(() => {
        const desktopNavigationElement = document.querySelector(".desktop-navigation");
        const targetId = desktopNavigationHandlerElement.getAttribute("aria-controls");
        if (targetId) {
          const targetNavigationElement = desktopNavigationElement.querySelector(`.navigation-parent[aria-labelledby="${targetId}"]`);
          this.closeAllDesktopNavigationItems();
          targetNavigationElement.classList.add("js-active");
          const allDesktopNavigationHandlerElements = document.querySelectorAll(`.js-handle-desktop-navigation[aria-controls="${targetId}"]`);
          allDesktopNavigationHandlerElements.forEach((desktopNavigationHandlerElement2) => {
            desktopNavigationHandlerElement2.ariaExpanded = "true";
          });
          hideAnnouncementBar();
          this.setListenersForBannerImage();
          if (desktopNavigationElement.classList.contains("js-desktop-navigation-open")) {
          } else {
            this.setListernersForClosingDesktopNavigation();
          }
          desktopNavigationElement.classList.add("js-desktop-navigation-open");
        } else {
          this.closeAllDesktopNavigationItems();
        }
      }, 200);
      desktopNavigationHandlerElement.addEventListener("mouseleave", () => clearTimeout(openDesktopNavigationTimeout), { passive: true });
    });
    /**
     * Close desktop navigation.
     */
    __publicField(this, "closeDesktopNavigation", (headerNavigationElement) => {
      const announcementBarElement = document.querySelector('announcement-bar[data-role="announcement-bar"]');
      const announcementBarHeight = announcementBarElement.offsetHeight;
      const offset = announcementBarHeight * 3;
      const scrollPosition = window.scrollY;
      if (headerNavigationElement) {
        const closeDesktopNavigationTimeout = setTimeout(() => {
          const desktopNavigationElement = document.querySelector(".desktop-navigation");
          desktopNavigationElement.classList.remove("js-desktop-navigation-open");
          this.closeAllDesktopNavigationItems();
          this.removeListernersForClosingDesktopNavigation();
          this.removeListenersForBannerImage();
          if (scrollPosition < offset) {
            showAnnouncementBar();
          }
        }, 200);
        headerNavigationElement.addEventListener("mouseleave", () => clearTimeout(closeDesktopNavigationTimeout), { passive: true });
      } else {
        const desktopNavigationElement = document.querySelector(".desktop-navigation");
        desktopNavigationElement.classList.remove("js-desktop-navigation-open");
        this.closeAllDesktopNavigationItems();
        this.removeListernersForClosingDesktopNavigation();
        if (scrollPosition < offset) {
          showAnnouncementBar();
        }
      }
    });
    this.desktopNavigationElement = this;
    this.allDesktopNavigationHandlerElements = document.querySelectorAll(".js-handle-desktop-navigation");
    const handleDesktopNavigation = () => {
      this.allDesktopNavigationHandlerElements.forEach((desktopNavigationHandlerElement) => {
        desktopNavigationHandlerElement.addEventListener("mouseenter", () => this.openDesktopNavigation(desktopNavigationHandlerElement), true, { passive: true });
      });
    };
    handleDesktopNavigation();
    window.addEventListener("resize", () => {
      handleDesktopNavigation();
    });
  }
};
if (customElements.get("desktop-navigation") === void 0) {
  customElements.define("desktop-navigation", DesktopNavigation);
}
